import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted, reactive, ref } from 'vue'
import { type TableColumnsType } from 'ant-design-vue'
import { type Pagination, type LogDataListItem } from '../types'
import { getLog } from '../service'
import BaseTable from './base-table/index.vue'
import dayjs from 'dayjs'
import { Modal } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'log-dialog',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  id: {
    type: Number,
    default: 0,
  },
  itemText: {
    type: String,
    default: '',
  },
},
  emits: ['update:visible', 'submit'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit
const innerVisible = computed({
  get() {
    return props.visible
  },
  set(val) {
    emits('update:visible', val)
  },
})

const isLoading = ref<boolean>(false)
const tableData = ref<LogDataListItem[]>()
const pagination = reactive<Pagination>({
  pageSize: 100,
  page: 1,
  total: 0,
})

const getList = () => {
  isLoading.value = true

  getLog(
    props.id,
    pagination.page,
    pagination.pageSize,
  )
    .then(res => {
      const list = res.list || []

      list.forEach(i => {
        i.operateTimeFE = dayjs(+i.operateTime * 1000).format('YYYY-MM-DD HH:mm:ss')
      })

      tableData.value = list
      pagination.total = +res.total
    })
    .finally(() => {
      isLoading.value = false
    })
}

const onChangePage = (page: number) => {
  pagination.page = page
  getList()
}

onMounted(() => {
  getList()
})

const handleOk = () => {
  innerVisible.value = false
}

const columns = ref<TableColumnsType>([
  {
    title: '操作人',
    dataIndex: 'operateUser',
    resizable: true,
    width: 100,
  },
  {
    title: '操作时间',
    dataIndex: 'operateTimeFE',
    resizable: true,
    width: 100,
  },
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    open: innerVisible.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((innerVisible).value = $event)),
    title: "日志",
    width: "1016px",
    onCancel: _cache[1] || (_cache[1] = ($event: any) => (innerVisible.value = false)),
    onOk: handleOk
  }, {
    default: _withCtx(() => [
      _createVNode(BaseTable, {
        columns: columns.value,
        "is-loading": isLoading.value,
        pagination: pagination,
        "table-data": tableData.value,
        "table-height": "45vh",
        onChangePage: onChangePage
      }, null, 8, ["columns", "is-loading", "pagination", "table-data"])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})